import React from 'react';
import {css} from 'emotion';
import IconEasyHome from '../../../common/material-easy-ui/icon/IconEasyHome';
import IconEasyProfile from '../../../common/material-easy-ui/icon/IconEasyProfile';
import IconEasySurvey from '../../../common/material-easy-ui/icon/IconEasySurvey';
import IconEasyNews from '../../../common/material-easy-ui/icon/IconEasyNews';
import ItemMenuMobile from './components/ItemMenuMobile';

const MenuMobile = (props) =>{
  return(
    <div className={css`height:60px;background-color:white;position:fixed;left:0px;bottom:0px;z-index:100;width:100%;
       -moz-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.2);
          -webkit-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.2);
          -o-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.2);
          box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.2);
          display:flex;flex-direction:row;
          `}>

          <ItemMenuMobile location={props.location} pathname={['/']} size={30} text={'Accueil'}>
            <IconEasyHome color={'#0085C6'} size={30}/>
            </ItemMenuMobile>
            <ItemMenuMobile location={props.location} pathname={['/profil']}  size={30} text={'Profil'}>
              <IconEasyProfile color={'#0085C6'} size={30}/>
            </ItemMenuMobile>
              <ItemMenuMobile location={props.location} pathname={['/liste-formulaire','/navire-formulaire']}  size={30} text={'Formulaire'}>
                <IconEasySurvey color={'#0085C6'} size={30}/>
            </ItemMenuMobile>
            <ItemMenuMobile location={props.location} pathname={['/vos-déclarations']}  size={30} text={'Déclaration'}>
                <IconEasyNews color={'#0085C6'} size={30}/>
            </ItemMenuMobile>
    </div>
  )
}

export default MenuMobile
